/* eslint-disable @typescript-eslint/camelcase */

import { FcsFlag } from "../unleash";

const FcsPermissionIncomingProcessSTIDest = {
  permission_sti_dest_enable: new FcsFlag.Flag(false),
  permission_sti_dest_create: new FcsFlag.Flag(false),
  permission_sti_dest_detail: new FcsFlag.Flag(false),
  flag_reverse_scan_sti_dest_enable: new FcsFlag.Flag(false)
}

export const FlagsPermissionIncomingProcessSTIDest = {
  ...FcsPermissionIncomingProcessSTIDest
};

export function initFlagsPermissionIncomingProcessSTIDest() {
  // register flags with namespaces for better grouping
  FcsFlag.register(
    "featureIncomingProcessSTIDest",
    FcsPermissionIncomingProcessSTIDest
  );
}
